export default "__VITE_ASSET__b8414e88__"